export default __webpack_public_path__ + "537c0b071829b5a3da4b51eaaf9adbd6.wav";